import {
  ref,
  computed,
} from 'vue'

import {
  defineStore,
} from 'pinia'

import {
  FormProps,
  FormInstance
} from 'ant-design-vue'

import {
  RuleObject
} from 'ant-design-vue/es/form'

import {
  defHttp
} from 'xmgoing-server'

const defaultModel = {
  password: '',
  tenantCode: [] as string[],
  pwdKey: '',
  securityKey: '',
}

type Model = typeof defaultModel


function createDefaultModel () {
  return {
    ...defaultModel
  }
}

export const useXmTenantFormStore = defineStore('xm-tenant-form', () => {
  const {
    t
  } = useI18n()

  const FormRef = ref<FormInstance>()
  const model = ref(createDefaultModel())

  const rules = computed<Partial<{[K in keyof Model]: RuleObject[]}>>(() => {
    return {
      tenantCode: [
        {
          required: true,
          message: t('请选择用户')
        }
      ],

      password: [
        {
          required: true,
          message: t('请输入密码')
        },
        {
          min: 6,
          max: 20,
          message: t('密码长度在6 ~ 20个字符')
        }
      ]
    }
  })

  const formProps = computed<FormProps>(() => {
    return {
      model: model.value,
      rules: rules.value
    }
  })

  function validate () {
    return FormRef.value!.validate()
  }

  function resetFields () {
    FormRef.value?.resetFields()
    model.value = createDefaultModel()
  }

  function getModel () {
    return {
      ...unref(model),
      tenantCode: unref(model).tenantCode.at(-1)
    }
  }

  async function getSecurityKey  () {
    try {
      const {
        securityCode,
        securityKey
      } = await defHttp.get({
        url: '/blade-auth/login/getUserLoginKey'
      })
      console.log({
        securityCode,
        securityKey
      })

      Object.assign(model.value, {
        pwdKey: securityCode,
        securityKey
      })
    } catch (e) {
      Object.assign(model.value, {
        pwdKey: '',
        securityKey: ''
      })
    }
  }

  return {
    FormRef,
    formProps,
    validate,
    resetFields,
    getModel,
    getSecurityKey,
    model
  }
})
